import React, { useContext, useEffect, useState } from "react";
import styles from "./WhatsappLike.module.css";
import whatsappLike from "../../assests/whatsappLike.svg";
import singinCloseButton from "../../assests/singinCloseButton.svg";
import success from "../../assests/share/copySuccessRound.svg";
import copyLinkImage from "../../assests/share/copyLinkBlack.svg";
import copySuccess from "../../assests/share/copySuccessBlack.svg";
import { useUserAuth } from "../../context/UserAuthContext";
import Context from "../../context/Context";
import axios from "axios";

const WhatsappLike = ({ setPopup, entry, type }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const {
    userDetailsFromApi,
    whatsappVerified,
    setWhatsappVerified,
    userIdToken,
    currentUser,
  } = useUserAuth();
  const { likeMap, setLikeMap, isMobile } = useContext(Context);
  const [copied, setCopied] = useState(false);
  const [nameEmpty, setNameEmpty] = useState(false);
  const [name, setName] = useState(userDetailsFromApi?.userName || "");
  const [messageSented, setMessageSented] = useState(false);
  const token = userIdToken || currentUser?.accessToken;
  const [number, setNumber] = useState({ countryCode: "+91" });
  const [otp, setOtp] = useState("");
  const [wpLoading, setWpLoading] = useState(false);
  const [enterOtp, setEnterOtp] = useState(false);
  const [optError, setOtpError] = useState("");
  const [otpVerified, setOptVerified] = useState(false);
  let tinyUrl = `vidu${entry?.userId}o${entry?.orgId}cp${entry?.campaignId}cn${entry?.contestId}e${entry?._id}`;
  let message = "";
  if (type == "vote") {
    message = name
      ? `#VoteRequest, 
Name:'${entry?.participantName}'. participationId:${tinyUrl}, From:${name}.`
      : `#VoteRequest, 
Name:'${entry?.participantName}'. participationId:${tinyUrl},`;
  } else {
    message = name
      ? `#votingWithValidation, 
Name:'${entry?.participantName}'. participationId_US${userDetailsFromApi?.userId}:${tinyUrl}. From:${name}.`
      : `#votingWithValidation, 
Name:'${entry?.participantName}'. participationId_US${userDetailsFromApi?.userId}:${tinyUrl}.`;
  }

  const handleWhatsappLike = () => {
    if (!name?.replace(/\s/g, "")) {
      setNameEmpty(true);
      return;
    }
    let phoneNumber = "+918618406454";
    const encodedContent = encodeURIComponent(message);
    const notDesktop =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    if (notDesktop) {
      const url = `https://wa.me/${phoneNumber}?text=${encodedContent}`;
      window.open(url, "_blank");
    } else {
      const url = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedContent}`;
      window.open(url, "_blank");
    }
    setTimeout(setMessageSented(true), 2000);
  };

  const handleWhatsappOtp = async () => {
    try {
      setWpLoading(true);
      const phoneNumber = number?.countryCode + number?.number;
      let config = {
        method: "PATCH",
        url: `${process.env.REACT_APP_WHATSAPP_GENERATE_OTP}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          phoneNumber,
        },
      };
      const response = await axios(config);
      if (response?.data?.status == "success") {
        setEnterOtp(true);
      }
      setWpLoading(false);
    } catch (error) {
      setWpLoading(false);
      console.log("error", error?.message);
    }
  };
  const handleVerifyOtp = async () => {
    try {
      setWpLoading(true);
      let config = {
        method: "PATCH",
        url: `${process.env.REACT_APP_WHATSAPP_VERIFY_OTP}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          otp,
        },
      };
      const response = await axios(config);
      if (response?.data?.status == "success") {
        setOptVerified(true);
        setMessageSented(
          "Verified! Your vote will be reflected soon in the participation"
        );
        setWhatsappVerified(true);
      } else {
        setOtpError("Enter Valid OTP");
      }
      setWpLoading(false);
    } catch (error) {
      setWpLoading(false);
      console.log("error", error?.message);
    }
  };
  function copyLink() {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, [1000]);
    navigator.clipboard.writeText(message);
    window.document.execCommand("copy");
  }

  const handleClose = () => {
    const updatedLikeMap = new Map(likeMap);
    let mapId = "con" + entry?._id;
    let likeObj = updatedLikeMap.get(mapId);
    likeObj.likesCount = likeObj?.likesCount + 1;
    likeObj.liked = true;
    updatedLikeMap.set(mapId, likeObj);
    setLikeMap(updatedLikeMap);
    setPopup(false);
  };
  return (
    <div className={styles.mainDiv}>
      <div className={styles.container}>
        <div className="w-[100%] flex justify-end py-[10px] cursor-pointer">
          <img
            src={singinCloseButton}
            onClick={() => {
              setPopup(false);
              // setReqForLike(false);
            }}
          />
        </div>
        <h3 className="text-large-medium mb-[14px] text-white uppercase flex items-center gap-[5px]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width="48px"
            height="48px"
            fill-rule="evenodd"
            clip-rule="evenodd"
            className="w-[28px] h-[28px]"
          >
            <path
              fill="#fff"
              d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"
            />
            <path
              fill="#fff"
              d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"
            />
            <path
              fill="#cfd8dc"
              d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"
            />
            <path
              fill="#40c351"
              d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"
            />
            <path
              fill="#fff"
              fill-rule="evenodd"
              d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"
              clip-rule="evenodd"
            />
          </svg>
          Vote via Whatsapp
        </h3>
        {(isMobile && !whatsappVerified) || otpVerified ? (
          <>
            {messageSented ? (
              <div className="w-full p-[16px] rounded-[6px] bg-white w-full">
                <p>{messageSented}</p>
              </div>
            ) : (
              <>
                {enterOtp ? (
                  <div className="w-full p-[16px] rounded-[6px] bg-white w-full">
                    <p className="text-regular-bold text-left text-opacity-80 mb-[12px]">
                      We have send you a code to{" "}
                      {number?.countryCode + number?.number}
                    </p>
                    <div className="w-full">
                      <input
                        type="text"
                        id="otp"
                        name="otp"
                        placeholder="Enter your OTP"
                        className="text-regular"
                        onChange={(e) => setOtp(e.target.value)}
                        value={otp}
                      />
                      {optError && (
                        <div className="text-small text-left w-[100%] mb-[12px]">
                          <span className="text-red-600">* </span>
                          {optError}
                        </div>
                      )}
                    </div>
                    <p className="text-regular-bold text-left text-opacity-80 my-[12px]"></p>

                    <div className="mb-[20px]">
                      <div className={`px-[20px] ${styles.whatsappLogin}`}>
                        <button
                          className={`${styles.button} text-regular-medium bg-[#7AC280]   flex items-center justify-center gap-[14px] drop-shadow-lg`}
                          onClick={handleVerifyOtp}
                          disabled={wpLoading}
                        >
                          <img
                            src={whatsappLike}
                            alt=""
                            className="h-[24px] w-[24px]"
                          />

                          {wpLoading ? "Loading" : "Verify"}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="w-full p-[16px] rounded-[6px] bg-white w-full">
                    <p className="text-regular-bold text-left text-opacity-80 mb-[12px]">
                      Verify your WhatsApp number via OTP.
                    </p>
                    <div className="w-full">
                      <div class={styles.phoneInput}>
                        <input
                          type="text"
                          id="countryCode"
                          name="countryCode"
                          maxlength="4"
                          className="text-regular-callout"
                          onChange={(e) =>
                            setNumber((prevState) => ({
                              ...prevState,
                              countryCode: e.target.value,
                            }))
                          }
                          autoComplete="off"
                          value={number?.countryCode}
                          // readOnly
                        />
                        <input
                          type="number"
                          id="number"
                          name="number"
                          placeholder="Enter your Whatsapp Number"
                          onChange={(e) =>
                            setNumber((prevState) => ({
                              ...prevState,
                              number: e.target.value,
                            }))
                          }
                          value={number?.number}
                        />
                      </div>

                      {nameEmpty && (
                        <div className="text-small text-left w-[100%] mb-[12px]">
                          <span className="text-red-600">* </span>
                          Enter your Whatsapp Number
                        </div>
                      )}
                    </div>
                    <p className="text-regular-bold text-left text-opacity-80 my-[12px]"></p>

                    <div className="mb-[20px]">
                      <div className={`px-[20px] ${styles.whatsappLogin}`}>
                        <button
                          className={`${styles.button} text-regular-medium bg-[#7AC280]   flex items-center justify-center gap-[14px] drop-shadow-lg`}
                          onClick={handleWhatsappOtp}
                          disabled={wpLoading}
                        >
                          <img
                            src={whatsappLike}
                            alt=""
                            className="h-[24px] w-[24px]"
                          />

                          {wpLoading ? "Loading" : "Get OTP"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        ) : (
          <div className="w-full p-[16px] rounded-[6px] bg-white w-full">
            <p className="text-regular-bold text-left text-opacity-80 mb-[12px]">
              Enter your name
            </p>
            <div className="w-full">
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Enter your name"
                className="text-regular"
                onChange={(e) => setName(e.target.value)}
                value={name}
              />
              {nameEmpty && (
                <div className="text-small text-left w-[100%] mb-[12px]">
                  <span className="text-red-600">* </span>
                  Enter your name
                </div>
              )}
            </div>
            <p className="text-regular-bold text-left text-opacity-80 my-[12px]">
              Go to Whatsapp and Cast Vote
            </p>

            <div className="mb-[20px]">
              {messageSented ? (
                <p className="text-small text-opacity-80  flex items-center gap-[5px]">
                  <img src={copySuccess} alt="" className="w-[36px] h-[36px]" />
                  Your vote will be reflected soon in the participation
                </p>
              ) : (
                <div className={`px-[20px] ${styles.whatsappLogin}`}>
                  <button
                    className={`${styles.button} text-regular-medium bg-[#7AC280]   flex items-center justify-center gap-[14px] drop-shadow-lg`}
                    onClick={handleWhatsappLike}
                  >
                    <img
                      src={whatsappLike}
                      alt=""
                      className="h-[24px] w-[24px]"
                    />
                    {/* Take me to Whatsapp */}
                    Open Whatsapp
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        <div className="flex items-center gap-[18px] my-[20px] w-full">
          <div className="seperator" />
          <p className="text-regular-medium text-white ">OR</p>
          <div className="seperator " />
        </div>

        <div className="w-full p-[16px] rounded-[6px] bg-white ">
          <div className="w-full mb-[18px]">
            <p className="text-small text-left mb-[5px]">1. Enter your name</p>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter your name"
              className="text-regular"
              onChange={(e) => setName(e.target.value)}
              value={name}
            />
            {nameEmpty && (
              <div className="text-small text-left w-[100%] mb-[12px]">
                <span className="text-red-600">* </span>
                Enter your name
              </div>
            )}
          </div>
          <div className="w-full">
            <p className="text-small text-left mb-[5px]">
              2. Copy the below whatsApp message with entry details
            </p>

            <div className="w-full">
              <div
                className="flex flex-row items-center w-full justify-between gap-[5px] cursor-pointer w-[100%] p-[10px] border-[1px] border-[#7AC280] rounded-[8px]"
                onClick={copyLink}
                tooltip="Copy to clipboard"
              >
                <p className="text-small break-words text-[#858585] w-[90%]">
                  {message}
                </p>
                <div className="w-[10%]">
                  {copied ? (
                    <img src={copySuccess} className="w-[20px] h-[20px]" />
                  ) : (
                    <img src={copyLinkImage} className="w-[20px] h-[20px]" />
                  )}
                </div>
              </div>
            </div>
            <p className="text-small text-left mt-[18px]  mb-[5px]">
              3. Open WhatsApp
            </p>
            <p className="text-small text-left mt-[18px] mb-[5px]">
              4. Sent whatsApp message to the number:{" "}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                width="48px"
                height="48px"
                fill-rule="evenodd"
                clip-rule="evenodd"
                className="w-[15px] h-[15px] inline"
              >
                <path
                  fill="#fff"
                  d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"
                />
                <path
                  fill="#fff"
                  d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"
                />
                <path
                  fill="#cfd8dc"
                  d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"
                />
                <path
                  fill="#40c351"
                  d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"
                />
                <path
                  fill="#fff"
                  fill-rule="evenodd"
                  d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z"
                  clip-rule="evenodd"
                />
              </svg>
              +918618406454
            </p>
            <p className="text-small text-center mt-[18px] mb-[5px] text-red-600">
              Note : Voting only through WhatsApp
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsappLike;
